import {
    Alert,
    Button,
    CircularProgress,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";

import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    DeleteUtility,
    getAllUtility,
    reset,
    searchUtility,
} from "../../Redux/UtilityProviders/UtilitySlice";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import { saveObj } from "../../Redux/SaveObjToUpdate/SaveSlice";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DeleteModal } from "../../Components/Modal/Modals";

const AllUtility = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const [currentId, setCurrentId] = useState();

    // Set Paginate Page Number && Paginate Rows Page
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Filter By Fields Variables
    const [title, setTitle] = useState("");
    const [state, setState] = useState("");
    const [rate, setRate] = useState("");
    const [annual_increase_percentage, setAnnualIncreasePercentage] =
        useState("");

    const searchObj = {
        title,
        state,
        rate,
        annual_increase_percentage,
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                searchUtility({ ...searchObj, paginate: event.target.value })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        const callSearchAction = async () => {
            await dispatch(
                searchUtility({
                    ...searchObj,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };
    const handelFilterAction = async () => {
        await dispatch(searchUtility({ ...searchObj, paginate: rowsPerPage }));
        await dispatch(reset());
    };

    const handelResetData = () => {
        setTitle("");
        setState("");
        setRate("");
        setAnnualIncreasePercentage("");

        const getUtility = async () => {
            await dispatch(getAllUtility());
            await dispatch(reset());
        };
        getUtility();
    };

    const HandelSaveObj = (obj) => {
        dispatch(saveObj(obj));
    };

    // Delete Utility Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const DeleteRow = async () => {
        handleClose();
        await setCurrentId(data.id);
        await dispatch(
            DeleteUtility({
                utility_provider_id: data.id,
            })
        );
        await dispatch(reset());
    };

    const handelDeleteUtility = async (data) => {
        handleOpen(data);
    };

    //get the Utility
    useEffect(() => {
        const getUtility = async () => {
            await dispatch(getAllUtility());
            await dispatch(reset());
        };
        getUtility();
    }, [path]);

    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    function inputKeyUp(e) {
        e.which = e.which || e.keyCode;
        if (e.which === 13) {
            //Key code of Enter
            handelFilterAction(searchObj);
        }
    }

    //get the utility
    const { utility, isLodaing } = useSelector(
        (state) => state.utility_providers
    );

    const UtilityTable = utility?.data?.data || [];
    const utilityPaginate = utility?.data || [];

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell
                                    style={{ padding: "5px" }}
                                    width={500}
                                >
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="title"
                                            name="title"
                                            label="Title"
                                            value={title}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setTitle(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="state"
                                            name="state"
                                            label="State"
                                            value={state}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setState(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="rate"
                                            name="rate"
                                            label="Rate"
                                            value={rate}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setRate(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="annual_increase_percentage"
                                            name="annual_increase_percentage"
                                            label="Annual Increase Percentage"
                                            value={annual_increase_percentage}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setAnnualIncreasePercentage(
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableHeadStyled>
                            <TableRow>
                                <TableCell width={100}>#</TableCell>
                                <TableCell width={400}>TILIE</TableCell>
                                <TableCell width={200}>State </TableCell>
                                <TableCell>Rate </TableCell>
                                <TableCell align="center">
                                    {" "}
                                    Annual Increase Percentage
                                </TableCell>

                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {UtilityTable?.map((key, index) => (
                                <TableRowStyled key={key?.id}>
                                    <TableCellStyle>
                                        {rowsPerPage * page + index + 1}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.title}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.state?.name}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.rate}</TableCellStyle>
                                    <TableCellStyle align="center">
                                        {Number(
                                            key.annual_increase_percentage * 100
                                        ).toFixed(1) + "%"}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <IconButton
                                            onClick={(e) => {
                                                HandelSaveObj(key);
                                            }}
                                        >
                                            <Link to={"edit=" + key.id}>
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={() =>
                                                handelDeleteUtility(key)
                                            }
                                        >
                                            {isLodaing && currentId == key.id && (
                                                <ProgressStyled>
                                                    <CircularProgress
                                                        size={30}
                                                        color="error"
                                                    />
                                                </ProgressStyled>
                                            )}

                                            <ProgressStyled>
                                                <Delete color="error" />
                                            </ProgressStyled>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>

                        <TableHeadStyled>
                            <TableRow>
                                {utilityPaginate.total >= 20 && (
                                    <TablePagination
                                        rowsPerPageOptions={[
                                            20,
                                            50,
                                            100,
                                            { label: "All", value: -1 },
                                        ]}
                                        colSpan={12}
                                        count={utilityPaginate.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </TableRow>
                        </TableHeadStyled>
                    </Table>

                    {utilityPaginate.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                </TableContainerStyled>
            )}
            {/* delete modal  */}
            <DeleteModal
                open={open}
                close={handleClose}
                title={data?.title}
                onClick={DeleteRow}
                loading={isLodaing}
            />
        </>
    );
};

export default AllUtility;
